// create slices
import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../../common/services/api-status.enum";

const initialState = {
  adminGroupUsers: {
    adminGroupUsersData: {
      data: {},
      status: ApiStatus.NONE,
      error: null,
    },
  },
  addAdminGroupUser: {
    addAdminGroupUserData: {
      data: {},
      status: ApiStatus.NONE,
      error: null,
    },
  },
  allUsers: {
    allUsersData: {
      data: {},
      status: ApiStatus.NONE,
      error: null,
    },
  },
  usersHistory: {
    usersHistoryData: {
      data: {},
      status: ApiStatus.NONE,
      error: null,
    },
  },
  editUser: {
    editUserData: {
      data: {},
      status: ApiStatus.NONE,
      error: null,
    },
  },
  deleteUser: {
    deleteUserData: {
      data: {},
      status: ApiStatus.NONE,
      error: null,
    },
  },
  addUser: {
    addUserData: {
      data: {},
      status: ApiStatus.NONE,
      error: null,
    },
  },
  deleteAdminGroupUser: {
    deleteAdminGroupUserData: {
      data: {},
      status: ApiStatus.NONE,
      error: null,
    },
  },
  usersRoles: {
    usersRolesData: {
      data: {},
      status: ApiStatus.NONE,
      error: null,
    },
  },
  plannedOutageUsers: {
    plannedOutageUsersData: {
      data: {},
      status: ApiStatus.NONE,
      error: null,
    },
  },
  addPlannedOutageUser: {
    addPlannedOutageUserData: {
      data: {},
      status: ApiStatus.NONE,
      error: null,
    },
  },
  deletePlannedOutageUser: {
    deletePlannedOutageUserData: {
      data: {},
      status: ApiStatus.NONE,
      error: null,
    },
  },
};

const userManagementSlice = createSlice({
  name: "userManagement",
  initialState,
  reducers: {
    //get admin users data
    getAdminUsersData: (state) => {
      state.adminGroupUsers.adminGroupUsersData.status = ApiStatus.LOADING;
      state.adminGroupUsers.adminGroupUsersData.error = null;
    },
    getAdminUsersDataSuccess: (state, action) => {
      state.adminGroupUsers.adminGroupUsersData.data = action.payload;
      state.adminGroupUsers.adminGroupUsersData.status = ApiStatus.SUCCESS;
      state.adminGroupUsers.adminGroupUsersData.error = null;
    },
    getAdminUsersDataFailure: (state, action) => {
      state.adminGroupUsers.adminGroupUsersData.status = ApiStatus.ERROR;
      state.adminGroupUsers.adminGroupUsersData.error = action.payload;
    },
    //add admin user
    getAddAdminGroupUserData: (state) => {
      state.addAdminGroupUser.addAdminGroupUserData.status = ApiStatus.LOADING;
      state.addAdminGroupUser.addAdminGroupUserData.error = null;
    },
    getAddAdminGroupUserDataSuccess: (state, action) => {
      state.addAdminGroupUser.addAdminGroupUserData.data = action.payload;
      state.addAdminGroupUser.addAdminGroupUserData.status = ApiStatus.SUCCESS;
      state.addAdminGroupUser.addAdminGroupUserData.error = null;
    },
    getAddAdminGroupUserDataFailure: (state, action) => {
      state.addAdminGroupUser.addAdminGroupUserData.status = ApiStatus.ERROR;
      state.addAdminGroupUser.addAdminGroupUserData.error = action.payload;
    },
    //get all users data
    getAllUsersData: (state) => {
      state.allUsers.allUsersData.status = ApiStatus.LOADING;
      state.allUsers.allUsersData.error = null;
    },
    getAllUsersDataSuccess: (state, action) => {
      state.allUsers.allUsersData.data = action.payload;
      state.allUsers.allUsersData.status = ApiStatus.SUCCESS;
      state.allUsers.allUsersData.error = null;
    },
    getAllUsersDataFailure: (state, action) => {
      state.allUsers.allUsersData.status = ApiStatus.ERROR;
      state.allUsers.allUsersData.error = action.payload;
    },
    //get user history data
    getUserHistoryData: (state) => {
      state.usersHistory.usersHistoryData.status = ApiStatus.LOADING;
      state.usersHistory.usersHistoryData.error = null;
    },
    getUserHistoryDataSuccess: (state, action) => {
      state.usersHistory.usersHistoryData.data = action.payload;
      state.usersHistory.usersHistoryData.status = ApiStatus.SUCCESS;
      state.usersHistory.usersHistoryData.error = null;
    },
    getUserHistoryDataFailure: (state, action) => {
      state.usersHistory.usersHistoryData.status = ApiStatus.ERROR;
      state.usersHistory.usersHistoryData.error = action.payload;
    },
    //edit user data
    getEditUserData: (state) => {
      state.editUser.editUserData.status = ApiStatus.LOADING;
      state.editUser.editUserData.error = null;
    },
    getEditUserDataSuccess: (state, action) => {
      state.editUser.editUserData.data = action.payload;
      state.editUser.editUserData.status = ApiStatus.SUCCESS;
      state.editUser.editUserData.error = null;
    },
    getEditUserDataFailure: (state, action) => {
      state.editUser.editUserData.status = ApiStatus.ERROR;
      state.editUser.editUserData.error = action.payload;
    },
    //delete user data
    getDeleteUserData: (state) => {
      state.deleteUser.deleteUserData.status = ApiStatus.LOADING;
      state.deleteUser.deleteUserData.error = null;
    },
    getDeleteUserDataSuccess: (state, action) => {
      state.deleteUser.deleteUserData.data = action.payload;
      state.deleteUser.deleteUserData.status = ApiStatus.SUCCESS;
      state.deleteUser.deleteUserData.error = null;
    },
    getDeleteUserDataFailure: (state, action) => {
      state.deleteUser.deleteUserData.status = ApiStatus.ERROR;
      state.deleteUser.deleteUserData.error = action.payload;
    },
    //add user data
    getAddUserData: (state) => {
      state.addUser.addUserData.status = ApiStatus.LOADING;
      state.addUser.addUserData.error = null;
    },
    getAddUserDataSuccess: (state, action) => {
      state.addUser.addUserData.data = action.payload;
      state.addUser.addUserData.status = ApiStatus.SUCCESS;
      state.addUser.addUserData.error = null;
    },
    getAddUserDataFailure: (state, action) => {
      state.addUser.addUserData.status = ApiStatus.ERROR;
      state.addUser.addUserData.error = action.payload;
    },
    //delete admin group user
    getDeleteAdminGroupUserData: (state) => {
      state.deleteAdminGroupUser.deleteAdminGroupUserData.status = ApiStatus.LOADING;
      state.deleteAdminGroupUser.deleteAdminGroupUserData.error = null;
    },
    getDeleteAdminGroupUserDataSuccess: (state, action) => {
      state.deleteAdminGroupUser.deleteAdminGroupUserData.data = action.payload;
      state.deleteAdminGroupUser.deleteAdminGroupUserData.status = ApiStatus.SUCCESS;
      state.deleteAdminGroupUser.deleteAdminGroupUserData.error = null;
    },
    getDeleteAdminGroupUserDataFailure: (state, action) => {
      state.deleteAdminGroupUser.deleteAdminGroupUserData.status = ApiStatus.ERROR;
      state.deleteAdminGroupUser.deleteAdminGroupUserData.error = action.payload;
    },
    //get users roles data
    getUsersRolesData: (state) => {
      state.usersRoles.usersRolesData.status = ApiStatus.LOADING;
      state.usersRoles.usersRolesData.error = null;
    },
    getUsersRolesDataSuccess: (state, action) => {
      state.usersRoles.usersRolesData.data = action.payload;
      state.usersRoles.usersRolesData.status = ApiStatus.SUCCESS;
      state.usersRoles.usersRolesData.error = null;
    },
    getUsersRolesDataFailure: (state, action) => {
      state.usersRoles.usersRolesData.status = ApiStatus.ERROR;
      state.usersRoles.usersRolesData.error = action.payload;
    },
    //get planned outage users data
    getPlannedOutageUsersData: (state) => {
      state.plannedOutageUsers.plannedOutageUsersData.status = ApiStatus.LOADING;
      state.plannedOutageUsers.plannedOutageUsersData.error = null;
    },
    getPlannedOutageUsersDataSuccess: (state, action) => {
      state.plannedOutageUsers.plannedOutageUsersData.data = action.payload;
      state.plannedOutageUsers.plannedOutageUsersData.status = ApiStatus.SUCCESS;
      state.plannedOutageUsers.plannedOutageUsersData.error = null;
    },
    getPlannedOutageUsersDataFailure: (state, action) => {
      state.plannedOutageUsers.plannedOutageUsersData.status = ApiStatus.ERROR;
      state.plannedOutageUsers.plannedOutageUsersData.error = action.payload;
    },
    //add planned outage user
    getAddPlannedOutageUserData: (state) => {
      state.addPlannedOutageUser.addPlannedOutageUserData.status = ApiStatus.LOADING;
      state.addPlannedOutageUser.addPlannedOutageUserData.error = null;
    },
    getAddPlannedOutageUserDataSuccess: (state, action) => {
      state.addPlannedOutageUser.addPlannedOutageUserData.data = action.payload;
      state.addPlannedOutageUser.addPlannedOutageUserData.status = ApiStatus.SUCCESS;
      state.addPlannedOutageUser.addPlannedOutageUserData.error = null;
    },
    getAddPlannedOutageUserDataFailure: (state, action) => {
      state.addPlannedOutageUser.addPlannedOutageUserData.status = ApiStatus.ERROR;
      state.addPlannedOutageUser.addPlannedOutageUserData.error = action.payload;
    },
    //delete planned outage user
    getDeletePlannedOutageUserData: (state) => {
      state.deletePlannedOutageUser.deletePlannedOutageUserData.status = ApiStatus.LOADING;
      state.deletePlannedOutageUser.deletePlannedOutageUserData.error = null;
    },
    getDeletePlannedOutageUserDataSuccess: (state, action) => {
      state.deletePlannedOutageUser.deletePlannedOutageUserData.data = action.payload;
      state.deletePlannedOutageUser.deletePlannedOutageUserData.status = ApiStatus.SUCCESS;
      state.deletePlannedOutageUser.deletePlannedOutageUserData.error = null;
    },
    getDeletePlannedOutageUserDataFailure: (state, action) => {
      state.deletePlannedOutageUser.deletePlannedOutageUserData.status = ApiStatus.ERROR;
      state.deletePlannedOutageUser.deletePlannedOutageUserData.error = action.payload;
    },
}});

export const {
  getAdminUsersData,
  getAdminUsersDataSuccess,
  getAdminUsersDataFailure,
  getAddAdminGroupUserData,
  getAddAdminGroupUserDataSuccess,
  getAddAdminGroupUserDataFailure,
  getAllUsersData,
  getAllUsersDataSuccess,
  getAllUsersDataFailure,
  getUserHistoryData,
  getUserHistoryDataSuccess,
  getUserHistoryDataFailure,
  getEditUserData,
  getEditUserDataSuccess,
  getEditUserDataFailure,
  getDeleteUserData,
  getDeleteUserDataSuccess,
  getDeleteUserDataFailure,
  getAddUserData,
  getAddUserDataSuccess,
  getAddUserDataFailure,
  getDeleteAdminGroupUserData,
  getDeleteAdminGroupUserDataSuccess,
  getDeleteAdminGroupUserDataFailure,
  getUsersRolesData,
  getUsersRolesDataSuccess,
  getUsersRolesDataFailure,
  getPlannedOutageUsersData,
  getPlannedOutageUsersDataSuccess,
  getPlannedOutageUsersDataFailure,
  getAddPlannedOutageUserData,
  getAddPlannedOutageUserDataSuccess,
  getAddPlannedOutageUserDataFailure,
  getDeletePlannedOutageUserData,
  getDeletePlannedOutageUserDataSuccess,
  getDeletePlannedOutageUserDataFailure
} = userManagementSlice.actions;

export default userManagementSlice.reducer;